<div class="popup-title-div d-flex justify-content-between align-items-center py-3 mb-1">
  <h2 class="text-center dialog-title pb-0" mat-dialog-title>
    {{'Samples' | translate}}
    <span class="sample-count-text">
      ({{ activeSamples.length }} {{ activeSamples.length === 1 ? ('sample' | translate) : ('samples' | translate) }}
      @if (outlierCount > 0) {
        <span>,
          {{ outlierCount }} {{ outlierCount === 1 ? ('outlier excluded' | translate) : ('outliers excluded' | translate) }}
        </span>
        })
      </span>
    </h2>
    <button class="btn close-icon px-2 py-0" (click)="dialogRef.close(outlierChanged)" [disabled]="isLoading">
      <mat-icon class="mr-0">close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="custom-scrollbar">
    @if (isLoading) {
      <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    }
    @if (!isLoading) {
      <div class="custom-theme-table">
        <div class="sample-list outer-bordered-table">
          <table>
            <thead>
              <tr class="sample-header">
                <th class="header-item">{{ 'Sample Number' | translate }}</th>
                <th class="header-item">{{ 'Survey Name' | translate }}</th>
                <th class="header-item">{{ 'Reported Value' | translate }}</th>
                <th class="header-item">{{ 'Substituted Value' | translate }}</th>
                <th class="header-item">{{ 'Start Date and Time' | translate }}</th>
                @if (!readOnly) {
                  <th class="header-item">{{ 'Actions' | translate }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (sample of activeSamples; track trackByIndex($index)) {
                <tr class="sample-item" [class.excluded-row]="sample.isExcluded">
                  <td class="item">{{ sample.sampleNumber ?? '-' }}</td>
                  <td class="item">{{ sample.surveyName }}</td>
                  <td class="item">{{ sample.displayValue }}</td>
                  <td class="item">{{ sample.substitutedDisplay }}</td>
                  <td class="item">{{ sample.startDate | dateFormat: dateFormat }}</td>
                  @if (!readOnly) {
                    <td class="item">
                      <div class="action-buttons">
                        <button class="btn btn-sm btn-outline-warning"
                          (click)="markAsOutlier(sample)"
                          [disabled]="isLoading || savingOutlierId === sample.id"
                          title="{{ 'Mark as Outlier' | translate }}">
                          @if (savingOutlierId !== sample.id) {
                            <span>
                              {{ 'Mark as Outlier' | translate }}
                            </span>
                          }
                          @if (savingOutlierId === sample.id) {
                            <mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
                          }
                        </button>
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (outlierSamples.length > 0) {
          <div class="outlier-section mt-3">
            <div class="outlier-section-header cursor-pointer d-flex align-items-center"
              (click)="showOutlierSection = !showOutlierSection">
              <span class="material-symbols-outlined mr-1">
                {{ showOutlierSection ? 'expand_more' : 'chevron_right' }}
              </span>
              <span class="outlier-section-title">
                {{ 'Excluded Outliers' | translate }} ({{ outlierSamples.length }})
              </span>
            </div>
            @if (showOutlierSection) {
              <div class="sample-list outer-bordered-table mt-1">
                <table>
                  <thead>
                    <tr class="sample-header">
                      <th class="header-item">{{ 'Sample Number' | translate }}</th>
                      <th class="header-item">{{ 'Survey Name' | translate }}</th>
                      <th class="header-item">{{ 'Reported Value' | translate }}</th>
                      <th class="header-item">{{ 'Substituted Value' | translate }}</th>
                      <th class="header-item">{{ 'Outlier Reason' | translate }}</th>
                      @if (!readOnly) {
                        <th class="header-item">{{ 'Actions' | translate }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (sample of outlierSamples; track trackByIndex($index)) {
                      <tr class="sample-item outlier-row" [class.excluded-row]="sample.isExcluded">
                        <td class="item">{{ sample.sampleNumber ?? '-' }}</td>
                        <td class="item">{{ sample.surveyName }}</td>
                        <td class="item">{{ sample.displayValue }}</td>
                        <td class="item">{{ sample.substitutedDisplay }}</td>
                        <td class="item">{{ sample.outlierReason ?? '-' }}</td>
                        @if (!readOnly) {
                          <td class="item">
                            <div class="action-buttons">
                              <button class="btn btn-sm btn-outline-success"
                                (click)="unmarkAsOutlier(sample)"
                                [disabled]="isLoading || savingOutlierId === sample.id"
                                title="{{ 'Unmark as Outlier' | translate }}">
                                @if (savingOutlierId !== sample.id) {
                                  <span>
                                    {{ 'Unmark as Outlier' | translate }}
                                  </span>
                                }
                                @if (savingOutlierId === sample.id) {
                                  <mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
                                }
                              </button>
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        }
      </div>
    }
  </mat-dialog-content>
